define(['exports', 'react', 'classnames', '../../assets/done.svg', '../../assets/error.svg', './ToolTipComponent', './styles/Field.css'], function (exports, _react, _classnames, _done, _error, _ToolTipComponent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _done2 = _interopRequireDefault(_done);

  var _error2 = _interopRequireDefault(_error);

  var _ToolTipComponent2 = _interopRequireDefault(_ToolTipComponent);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DEFAULT_WIDTH = 100;
  var PASSWORD = 'password';
  var handleKeyPress = function handleKeyPress(target, onEnter) {
    if (target.charCode === 13 && onEnter) {
      onEnter();
    }
  };

  var renderValidation = function renderValidation(value) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var valid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var inputType = arguments[3];
    var shouldHideValidationIcon = arguments[4];
    var shouldHideValidationMsg = arguments[5];

    if (error) {
      return _react2.default.createElement(
        'div',
        { className: 'red pt1 h6 flex items-center' },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'display-none': shouldHideValidationIcon }) },
          _react2.default.createElement(_error2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'pl1': !shouldHideValidationIcon, 'display-none': shouldHideValidationMsg }) },
          error
        )
      );
    } else if (value && inputType === PASSWORD && valid) {
      return _react2.default.createElement(
        'div',
        { className: 'secondary pt1 h6 flex items-center' },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('display-none') },
          _react2.default.createElement(_done2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'pl1': !shouldHideValidationIcon, 'display-none': shouldHideValidationMsg }) },
          valid
        )
      );
    }
  };

  var Field = function Field(_ref) {
    var label = _ref.label,
        inputType = _ref.inputType,
        width = _ref.width,
        _ref$defaultValue = _ref.defaultValue,
        defaultValue = _ref$defaultValue === undefined ? "" : _ref$defaultValue,
        value = _ref.value,
        _ref$msgs = _ref.msgs,
        msgs = _ref$msgs === undefined ? {} : _ref$msgs,
        tabIndex = _ref.tabIndex,
        _onChange = _ref.onChange,
        placeholder = _ref.placeholder,
        backgroundColor = _ref.backgroundColor,
        toolTipLabel = _ref.toolTipLabel,
        toolTipMessage = _ref.toolTipMessage,
        shouldHideValidationIcon = _ref.shouldHideValidationIcon,
        shouldHideValidationMsg = _ref.shouldHideValidationMsg,
        shouldHideRedBorder = _ref.shouldHideRedBorder,
        errorPosition = _ref.errorPosition,
        onEnter = _ref.onEnter;

    var inputWidth = (width || DEFAULT_WIDTH) + '%';
    var fieldStyling = (0, _classnames2.default)('text-field ', {
      'field-default-value': !value,
      'field-error': !shouldHideRedBorder && msgs.error
    });
    return _react2.default.createElement(
      'div',
      { className: 'text-field' },
      _react2.default.createElement(
        'div',
        { className: 'flex items-center' },
        _react2.default.createElement(
          'div',
          { className: 'bold nunito-font field-heading' },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'display-none': !toolTipMessage }) },
          _react2.default.createElement(_ToolTipComponent2.default, {
            className: 'clearfix ml1',
            toolTipId: label + ' ' + toolTipLabel,
            label: toolTipLabel,
            message: toolTipMessage })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)({ 'flex items-center': errorPosition !== 'bottom' }) },
        _react2.default.createElement('input', {
          tabIndex: tabIndex,
          className: fieldStyling + ' text-field',
          type: inputType,
          placeholder: placeholder,
          style: { width: inputWidth, backgroundColor: backgroundColor },
          value: value ? value : defaultValue,
          onFocus: function onFocus(e) {
            if (e.target.value === defaultValue) e.target.value = '';
          },
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          },
          onKeyPress: function onKeyPress(target) {
            return handleKeyPress(target, onEnter);
          } }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('red', { 'pl1 pt2': errorPosition !== 'bottom' }) },
          renderValidation(value, msgs.error, msgs.valid, inputType, shouldHideValidationIcon, shouldHideValidationMsg)
        )
      )
    );
  };

  exports.default = Field;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/Field.js
// module id = 105
// module chunks = 0